// extracted by mini-css-extract-plugin
module.exports = {"imageArea":"style-module--imageArea--3wp54","image":"style-module--image--2bh12"};